import { t as e } from "../../../../i18/index.js";
import r from "react";
function t(t) {
  var a = t.err,
    n = t.type;
  return r.createElement("div", null, r.createElement("div", {
    className: "attachment-error"
  }, r.createElement("span", {
    className: "attachment-error-file attachment-error-content"
  }, a.file.name), r.createElement("span", {
    className: "attachment-error-reason attachment-error-content"
  }, e("file-uploader.reasons." + n, a))));
}
function a(a) {
  var n = a.errors,
    o = a.type;
  return 0 === n.length ? null : r.createElement("div", {
    className: "upload-errors"
  }, r.createElement("span", {
    className: "upload-errors__summary"
  }, e("file-uploader.upload-error", {
    type: o,
    count: n.length
  })), n.map(function (e, a) {
    return r.createElement(t, {
      type: o,
      err: e,
      key: a
    });
  }));
}
export { a as UploadErrors };